import { render, staticRenderFns } from "./PreviousDeferredReportWarning.vue?vue&type=template&id=708058a4&"
import script from "./PreviousDeferredReportWarning.vue?vue&type=script&lang=js&"
export * from "./PreviousDeferredReportWarning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QItem,QItemSection,QIcon,QItemLabel} from 'quasar'
component.options.components = Object.assign({QCard,QCardSection,QItem,QItemSection,QIcon,QItemLabel}, component.options.components || {})
